<template>
	<div class="pagesContent">
			<!-- 顶栏容器 -->
				<el-card>
					<el-form ref="Search" :model="Search" label-width="100px" inline>
						<el-form-item label="公司编号">
							<el-input v-model="Search.CompanyId" placeholder="请输入公司编号" size="small" @change="searchSubmit"></el-input>
						</el-form-item>
						<el-form-item label="公司名称">
							<el-input v-model="Search.LikeCompanyName" placeholder="请输入公司名称" size="small" @change="searchSubmit">
							</el-input>
						</el-form-item>
						<el-form-item label="地区">
							<el-cascader size="small" :options="options" v-model="selectedOptions" clearable
								:props="{ checkStrictly: true }" popper-class='aaa' @change="chooseRegion">
							</el-cascader>
						</el-form-item>
					</el-form>
				</el-card>
			<!-- 主体内容 -->
				<el-card class="card-box section" style="margin-top: 10px;">
					<div class="single-title">
						注册信息
					</div>
					<div class="single-model-other">
						<el-table size="mini" max-height="500" :data="logMsg" stripe border style="width: 100%" >
							<el-table-column prop="CompanyID" label="序号" align="center" min-width="50"></el-table-column>
							<el-table-column prop="CompanyName" label="工厂名称" align="center" min-width="160"></el-table-column>
							<el-table-column prop="Deadline" label="到期时间" align="center" min-width="100">
								<template slot-scope="scope">{{scope.row.Deadline | dateYMDFormat}}</template>
							</el-table-column>
							<el-table-column prop="Stauts" label="商家状态" align="center" min-width="100">
								<template slot-scope="{row}">
									{{['','申请开通','申请充值','认证通过','认证失败','认证拒绝','停止使用'][row.Stauts]}}
								</template>
							</el-table-column>
							<el-table-column prop="VersionType" label="版本" align="center" min-width="50">
								<template slot-scope="{row}">
									{{['','单机','网络'][row.VersionType]}}
								</template>
							</el-table-column>
							<el-table-column prop="Remark" label="备注" align="center" min-width="200"></el-table-column>
							<el-table-column prop="VersionType" label="操作" align="center" width="110">
								<template>
									<el-button type="primary" size="mini">开通/续费</el-button>
								</template>
							</el-table-column>
						</el-table>
						<el-pagination style="margin-top: 10px;" background :current-page.sync="table.PageIndex" :page-size.sync="table.PageSize"
							:page-sizes="[10, 20, 40, 50]" layout="total,sizes, prev, pager, next" :total="table.TotalCount"
							@size-change="handleSizeChange" @current-change="getAllMsg">
						</el-pagination>
					</div>
				</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//顶部搜索
				Search: {
					CompanyId: '', //公司编号
					LikeCompanyName: '', // 公司名称
					ProvinceCode: '', //省代码
					CityCode: '', //市代码
					AreaCode: '', //区代码
				},
				//获取地区
				options: [],
				selectedOptions: [],
				table:{
					PageIndex:1,
					PageSize:10,
					TotalCount:null,
				},
				//注册信息
				logMsg:[],
			}
		},
		mounted() {
			this.getAddress()
      		this.getAllMsg()
		},
		methods: {
			getAllMsg(){
				this.$http.getAllMsgLog(this.table.PageIndex,this.table.PageSize,this.Search).then(res=>{
					console.log(res)
					if(res.status == 200) {
						this.logMsg = res.data.Items
						this.table.TotalCount = res.data.TotalCount
					}
				})
			},
			handleSizeChange(val) {
				this.table.PageIndex = 1
				this.getAllMsg()
			},
			/* 搜索 重置 */
			searchReset() {
				this.Search = this.$options.data.call(this).Search
			},
			/* 搜索 提交搜索 */
			searchSubmit() {
				this.table.PageIndex = 1
				this.getAllMsg()
			},
			/* 顶部选择地区 */
			chooseRegion(value) {
				// console.log(value)
				var regionList = value
				if (value.length == 3) {
					this.Search.ProvinceCode = regionList[0]
					this.Search.CityCode = regionList[1]
					this.Search.AreaCode = regionList[2]
				} else if (value.length == 2) {
					this.Search.ProvinceCode = regionList[0]
					this.Search.CityCode = regionList[1]
					this.Search.AreaCode = ""
				} else if (value.length == 1) {
					this.Search.ProvinceCode = regionList[0]
					this.Search.CityCode = ""
					this.Search.AreaCode = ""
				} else {
					this.Search.ProvinceCode = ""
					this.Search.CityCode = ""
					this.Search.AreaCode = ""
				}
				this.searchSubmit()
			},
			/* 获取地区 */
			getAddress() {
				this.$http.getAllAddress().then(res => {
					if (res.status == 200) {
						this.options = res.data
						// console.log(this.options)
					} else {
						this.$message.error({
							message: '查询地区失败！'
						})
					}
				})
			},
		}
	}
</script>

<style>
	.pagesContent {
		width: 100%;
		height: 100%;
	}

	.main-box {
		width: 100%;
		background-color: #FFFFFF;
	}


	/* 顶部地址 */
	.el-cascader-menu__wrap {
		height: 260px;
	}

	.el-cascader-menu {
		min-width: 260px;
	}

	.el-cascader-panel {
		font-size: 16px;
	}

	.aaa .el-radio__inner {
		top: -18px;
		left: -19px;
		border-radius: 0;
		border: 0;
		width: 170px;
		height: 34px;
		background-color: transparent;
		cursor: pointer;
		box-sizing: border-box;
		position: absolute;
	}
	.aaa .el-radio__input.is-checked .el-radio__inner {
		background: transparent;
	}

	.card-box {
		margin-bottom: 40px;
	}
	.single-model-other {
		padding-top: 10px;
	}
	.single-title {
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 20px;
		font-weight: 800;
		border-bottom: #CCCCCC 1px solid;
	}
	.single-model-company {
		padding: 20px 0 0 40px;
		margin-bottom: 40px;
	}

	.el-card__body{
		padding: 10px;
	}
</style>
